import { Link, NavLink, Navigate, Outlet } from "react-router-dom";
import { BarChart3, BookOpen, Sparkles, Briefcase, SearchCheck, ClipboardCheck, FileText, Inbox, LayoutDashboard, LogOut, Settings, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const allItems = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/posts", label: "Blog posts", icon: FileText },
  { to: "/admin/publications", label: "Publications", icon: BookOpen },
  { to: "/admin/case-studies", label: "Case studies", icon: Briefcase },
  { to: "/admin/triage", label: "Migration triage", icon: ClipboardCheck },
  { to: "/admin/leads", label: "Leads inbox", icon: Inbox },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/admin/evidence", label: "AI Evidence Finder", icon: Sparkles, admin: true },
  { to: "/admin/seo", label: "Page SEO", icon: SearchCheck },
  { to: "/admin/settings", label: "Settings & team", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-slate-500">Checking session…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;
  const items = allItems.filter((it) => !it.admin || user.role === "admin");

  return (
    <div data-testid="admin-layout" className="flex min-h-screen bg-[var(--surface)]">
      <aside className="hidden w-64 shrink-0 flex-col bg-[var(--navy)] text-slate-300 lg:flex">
        <div className="border-b border-white/10 px-6 py-5"><img src="/logo-white.png" alt="MarksMan" className="h-10 w-auto" /><div className="eyebrow mt-3 !text-teal-300">Admin CMS</div></div>
        <nav className="flex-1 space-y-1 px-3 py-4">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors duration-150 ${isActive ? "bg-white/10 text-white" : "hover:bg-white/5 hover:text-white"}`}>
              <it.icon size={17} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 p-4 text-xs">
          <div className="font-semibold text-white">{user.name}</div>
          <div className="mt-0.5 flex items-center gap-2 text-slate-400">{user.email}<span className="rounded bg-teal-500/20 px-1.5 py-0.5 font-mono uppercase text-teal-300">{user.role}</span></div>
          <div className="mt-3 flex gap-2">
            <Link to="/" target="_blank" className="btn-ghost !px-2 !py-1 !text-xs !text-slate-300 hover:!bg-white/10"><ExternalLink size={13} /> View site</Link>
            <button data-testid="admin-logout" onClick={logout} className="btn-ghost !px-2 !py-1 !text-xs !text-slate-300 hover:!bg-white/10"><LogOut size={13} /> Sign out</button>
          </div>
        </div>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2 overflow-x-auto border-b border-slate-200 bg-white px-4 py-2 lg:hidden">
          {items.map((it) => <NavLink key={it.to} to={it.to} end={it.end} className={({ isActive }) => `whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold ${isActive ? "bg-[var(--navy)] text-white" : "text-slate-600"}`}>{it.label}</NavLink>)}
          <button onClick={logout} className="ml-auto text-xs font-semibold text-slate-600">Sign out</button>
        </div>
        <main className="flex-1 p-4 sm:p-6 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
